/**
 * Open this app's page in the iPhone Settings app — where notifications are
 * switched on or off for Phieg (the store app has no switch of its own).
 *
 * `app-settings:` is iOS's own URL for that page. A window.open with a new
 * target is what the shell hands to iOS (Capacitor's createWebViewWith →
 * UIApplication.open), the same road the App Store button takes
 * (native/appStore.js). No-op outside the store app.
 */
import { Capacitor } from "@capacitor/core";

export const IOS_APP_SETTINGS_URL = "app-settings:";

export const canOpenIphoneSettings = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";

export function openIphoneSettings() {
  if (!canOpenIphoneSettings()) return false;
  window.open(IOS_APP_SETTINGS_URL, "_blank", "noopener");
  return true;
}
